/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum GeographicLocationEnum {
    Bucuresti = 'Bucuresti',
    Pitesti = 'Pitesti',
    Alexandria = 'Alexandria',
    Campulung = 'Campulung',
    RamnicuValcea = 'RamnicuValcea',
    Slatina = 'Slatina'
}

export function GeographicLocationEnumFromJSON(json: any): GeographicLocationEnum {
    return GeographicLocationEnumFromJSONTyped(json, false);
}

export function GeographicLocationEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeographicLocationEnum {
    return json as GeographicLocationEnum;
}

export function GeographicLocationEnumToJSON(value?: GeographicLocationEnum | null): any {
    return value as any;
}

